import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Display from '@loggi/ui/components/display';
import View from '@loggi/ui/components/view';
import {
  SIZES,
  LARGE_SIZE,
  REGULAR_SIZE,
  SMALL_SIZE
} from '@loggi/ui/components/utils/sizes';
import styles from '../index.scss';

function InputLabel(props) {
  const {
    text,
    helperText,
    disabled,
    size,
    component: Component,
    componentProps
  } = props;

  const classesLabel = classNames(
    styles.label,
    { [styles.labelDisabled]: disabled },
    { ['text-base']: size === REGULAR_SIZE },
    { ['text-sm']: size === SMALL_SIZE },
    { ['text-lg']: size === LARGE_SIZE }
  );

  const classesHelperText = classNames(styles.helperText, {
    [styles.helperTextDisabled]: disabled
  });

  return (
    <View inline>
      <Display when={() => Boolean(Component)}>
        {() => <Component {...componentProps} />}
      </Display>
      <Display when={() => Boolean(text) && !Boolean(Component)}>
        {() => (
          <label htmlFor="" className={classesLabel}>
            {text}
            <Display when={!!helperText}>
              <span className={classesHelperText}>{helperText}</span>
            </Display>
          </label>
        )}
      </Display>
    </View>
  );
}

InputLabel.propTypes = {
  text: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(SIZES),
  component: PropTypes.func,
  componentProps: PropTypes.object
};

InputLabel.defaultProps = {
  text: null,
  size: 'regular',
  disabled: false,
  component: null,
  componentProps: null
};

InputLabel.displayName = 'InputLabel';

export default InputLabel;
